const Answer = ({ text }: { text: string }) => {
  return (
    <div className='font-light whitespace-pre-wrap text-[#002652] select-text'>
      {text}
    </div>
  )
}

export default Answer
